export const LocationIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1481_3387)">
        <path
          d="M5.8125 7.3125C5.8125 8.20761 6.16808 9.06605 6.80101 9.69899C7.43395 10.3319 8.2924 10.6875 9.1875 10.6875C10.0826 10.6875 10.9411 10.3319 11.574 9.69899C12.2069 9.06605 12.5625 8.20761 12.5625 7.3125C12.5625 6.41739 12.2069 5.55895 11.574 4.92601C10.9411 4.29308 10.0826 3.9375 9.1875 3.9375C8.2924 3.9375 7.43395 4.29308 6.80101 4.92601C6.16808 5.55895 5.8125 6.41739 5.8125 7.3125Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.1875 2.8125V5.0625"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6875 7.3125H6.9375"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.1875 11.8125V9.5625"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6875 7.3125H11.4375"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9375 7.3121C15.9372 6.03496 15.5747 4.7841 14.8919 3.7048C14.2091 2.6255 13.2341 1.76204 12.0802 1.21473C10.9263 0.667412 9.64077 0.458691 8.37296 0.612807C7.10515 0.766924 5.90708 1.27755 4.91789 2.08539C3.92871 2.89322 3.189 3.96511 2.78468 5.17657C2.38036 6.38802 2.32803 7.68932 2.63376 8.92932C2.93948 10.1693 3.59073 11.2972 4.51185 12.1818C5.43297 13.0665 6.58616 13.6717 7.8375 13.9271L9.1875 17.4371L10.5375 13.9271C12.0621 13.6159 13.4324 12.7875 14.4165 11.582C15.4005 10.3766 15.9378 8.86818 15.9375 7.3121Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1481_3387">
          <rect width="18" height="18" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
